import axios from "axios";
import { getHeaders } from "../utility/getHeader";

/**
 * Cancels a record by updating its status to '2' and removing its ledger entries
 *
 * @param {string} tablename - Name of the table
 * @param {string} colname - Name of the identifying column (e.g., "id")
 * @param {string|number} colval - Value of the identifying column
 */
const updateRecord = async (tablename, colname, colval) => {
  try {
    if (!tablename || !colname || colval === undefined || colval === null) {
      console.error("Invalid arguments passed to cancelRecord");
      return;
    }

    // If cancelling a bill (final_bill table), remove its ledger entries
    // (transaction_id on ledger_entries is set to the bill id when it's created/edited)
    if (tablename === "final_bill" || tablename === "advance_final_bill") {
      try {
        await axios.delete(
          `/deletebyid/ledger_entries/transaction_id/${colval}`,
          getHeaders()
        );
        console.log(`Removed ledger entries for bill #${colval}`);
      } catch (ledgerError) {
        console.error("Error removing ledger entries:", ledgerError.message);
        // Continue with cancellation even if ledger cleanup fails
      }
    }

    // Update the record status to '2' (cancelled)
    const payload = {
      updatedFields: { status: "2" },
      where: { [colname]: colval },
    };

    const res = await axios.put(
      `/updatedata/${tablename}`,
      payload,
      getHeaders()
    );

    console.log("Cancelled:", res.data);
  } catch (err) {
    console.error("Cancel Error:", err.message);
    throw err;
  }
};

export default updateRecord;
